export const test_mixin = () => {
  window.console.log('TEST SITE SPECIFIC MIXIN')
}

export const textual_score = (score_map = { "10": "Eccezionale", "9": "Eccellente", "8": "Ottimo", "7": "Buono", "6": "Carino" }) => {
  const sorted_keys = Object.keys(score_map).sort((a, b) => a - b)
  return function (score) {
    const key = sorted_keys.find((current_key, index) => {
      const next_key = Number(sorted_keys[index + 1])
      return score >= current_key && (score < next_key || !next_key)
    })
    return score_map[key] || 'Mediocre'
  }
}

export const is_vivamod = () => {
  return (process.env.VUE_APP_PREFIX == "vm")
}

export const is_hotels = () => {
  return (process.env.VUE_APP_PREFIX == "vh")
}

export default {
  methods: {
    test_mixin: test_mixin,
    textual_score: textual_score,
    is_vivamod,
    is_hotels,
    //get_site_name,
  }
}